export const BRANDING_SOURCE = {
  template: 'template',
  organisation: 'organisation',
  disabled: 'disabled',
} as const;
